import { mallApi } from '../request'
import { apiPath } from '../api'

export const redPackageRain = {
  getDrawCount: data => mallApi.post(apiPath.getDrawCount, data),
  getLotterResult: data => mallApi.post(apiPath.getLotterResult, data),
  getDecreaseDrawCount: data => mallApi.post(apiPath.getDecreaseDrawCount, data)
}
